import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Form, Message, Table, Confirm, Checkbox,
} from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import Validator from 'validatorjs';
import { find, isEmpty } from 'lodash';
import ListRow from '../views/ProductSelection/ListRow';
import ContactForm from '../views/ProductSelection/ContactForm';
import createFlatRateOfferMutation from '../graphql/createFlatRateOfferMutation';
import createAndAcceptFlatRateOfferMutation from '../graphql/createAndAcceptFlatRateOfferMutation';

class ProductSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDealerNo: null,
      selectedDealerName: null,
      incompleteEnrollment: null,
      auctionAccessName: null,
      offers: [],
      email: null,
      phone: null,
      editedRate: null,
      baseRate: 0,
      errors: {},
      auctionAccessNumber: null,
      showConfirm: false,
      flashMessage: null,
      loading: false,
      isUpgrade: false,
      offerAccepted: false,
      userEmail: null,
      salesRepEmail: null,
      closedFactoryExclusion: false,
    };
  }

  componentDidMount() {
    const {
      selectedDealerNo,
      selectedDealerName,
      auctionAccessName,
      offers,
      email,
      phone,
      auctionAccessNumber,
      onChangeHandler,
      handleRadioButtonChange,
      isUpgrade,
      userEmail,
      salesRepEmail,
      enrollment,
    } = this.props;

    this.setState({
      selectedDealerNo,
      selectedDealerName,
      auctionAccessName,
      offers,
      email,
      phone,
      auctionAccessNumber,
      isUpgrade,
      userEmail,
      salesRepEmail,
    });

    const incompleteOffer = offers.filter(
      offer => offer && offer.incompleteEnrollment !== null
    )[0];
    if (incompleteOffer) {
      const { incompleteEnrollment } = incompleteOffer;
      const productName = incompleteEnrollment
        ? incompleteEnrollment.productName
        : null;

      const savedOfferIndex = offers.indexOf(
        find(offers, ['productName', productName])
      );

      if (incompleteEnrollment) {
        onChangeHandler('editedRate', incompleteEnrollment.price);
        this.setState({
          baseRate: incompleteEnrollment.basePriceDs,
          incompleteEnrollment,
          closedFactoryExclusion: incompleteEnrollment.closedFactoryExclusion,
        });
      }

      handleRadioButtonChange(savedOfferIndex);
    } else {
      this.setState({
        closedFactoryExclusion: enrollment[0].closedFactoryExclusion,
      });
    }
  }

  fieldUpdateHandler = (field, value) => {
    this.setState({ [field]: value, errors: {} });
  };

  validateEditedRate = (editedRate, chosenOffer, isUpgrade) => {
    if (
      parseInt(editedRate, 10) === 0
      || (parseInt(editedRate, 10) === parseInt(chosenOffer.rate, 10) && isUpgrade)
    ) {
      this.setState({
        flashMessage:
          'Override rate must be greater than zero and different from the SAS rate',
        loading: false,
      });
      return false;
    }
    return true;
  };

  validateBaseRate = (baseRate, chosenOffer) => {
    if (
      parseInt(baseRate || 0, 10) === 0
      && parseInt(chosenOffer.basePriceDs, 10) === 0
      && chosenOffer.productName.includes('PSI')
    ) {
      this.setState({
        flashMessage: 'Base Rate can not be zero',
        loading: false,
      });
      return false;
    }
    return true;
  };

  validateChosenIndex = chosenIndex => {
    if (chosenIndex === '') {
      this.setState({
        flashMessage: 'Please select one among the offers listed',
        loading: false,
      });
      return false;
    }
    return true;
  };

  validateChosenOffer = (chosenOffer, editedRate) => {
    if ((chosenOffer.rate === 0 && isEmpty(editedRate)) || editedRate === 0) {
      this.setState({
        flashMessage: 'Override amount must be greater than 0',
        loading: false,
      });
      return false;
    }
    return true;
  };

  validateEditedRateToOffer = (chosenOffer, editedRate, baseRate) => {
    if (
      !isEmpty(editedRate)
      && editedRate <= baseRate
      && chosenOffer.productName.includes('PSI')
    ) {
      this.setState({
        flashMessage:
          'The PSI Override amount must be greater than the Base Rate',
        loading: false,
      });
      return false;
    }
    return true;
  };

  validateRevisedOffer = (editedRate, chosenOffer) => {
    const { incompleteEnrollment } = this.state;
    if (
      incompleteEnrollment
      && chosenOffer.rate === incompleteEnrollment.price
      && chosenOffer.productName === incompleteEnrollment.productName
      && (isEmpty(editedRate) || editedRate === incompleteEnrollment.price)
    ) {
      this.setState({
        flashMessage: 'Exact same offer cannot be re-sent.',
        loading: false,
      });
      return false;
    }
    return true;
  };

  render() {
    const onCheckboxHandler = field => (event, data) => {
      this.setState({ [field]: data.checked });
    };

    const validationRules = {
      email: 'required|email',
      salesRepEmail: 'required|email',
      userEmail: 'required|email',
      editedRate: 'integer',
      baseRate: 'integer',
      auctionAccessName: 'required',
    };

    const {
      handleRadioButtonChange,
      chosenIndex,
      handleProductSelection,
      handleCancel,
      isRevise,
      onSearchSubmitHandler,
      enrollment,
      isUpgrade,
      chosenOffer,
    } = this.props;

    const {
      selectedDealerNo,
      selectedDealerName,
      incompleteEnrollment,
      auctionAccessName,
      offers,
      email,
      phone,
      editedRate,
      baseRate,
      errors,
      showConfirm,
      flashMessage,
      loading,
      offerAccepted,
      userEmail,
      salesRepEmail,
      closedFactoryExclusion,
    } = this.state;

    const handleConfirm = () => {
      this.setState({ showConfirm: false });
      handleProductSelection(email, phone);
      onSearchSubmitHandler();
    };

    const handleAccepted = () => {
      this.setState({ offerAccepted: false });
      handleProductSelection(email, phone);
      onSearchSubmitHandler();
    };

    const productname = isEmpty(enrollment[0].productName)
      ? `DealShield ${enrollment[0].days} Day`
      : enrollment[0].productName;

    const submitWithoutApproval = e => {
      e.preventDefault();
      this.setState({ loading: true });
      const {
        email: stateEmail,
        phone: statePhone,
        editedRate: stateEditedRate,
        auctionAccessName: stateAuctionAccessName,
        auctionAccessNumber: stateAuctionAccessNumber,
        isUpgrade: stateIsUpgrade,
        baseRate: stateBaseRate,
        userEmail: stateUserEmail,
        salesRepEmail: stateSalesRepEmail,
      } = this.state;
      const { createAndAcceptMutation, chosenOffer: propsChosenOffer } = this.props;

      const validation = new Validator(this.state, validationRules, {
        'required.email':
          'Please enter a valid email address for the offer recipient',
        email: 'Please enter a valid email address',
        userEmail: 'Please enter a valid user email address',
        salesRepEmail: 'Please enter a valid Sales Rep email address',
        integer: 'Please enter whole number',
        'required.auctionAccessName': 'Please enter a full name',
      });

      if (
        this.validateEditedRate(stateEditedRate, propsChosenOffer) === false
        || this.validateChosenIndex(chosenIndex) === false
        || this.validateRevisedOffer(stateEditedRate, propsChosenOffer) === false
      ) {
        return false;
      }

      if (validation.fails()) {
        this.setState(prevState => ({ ...prevState, ...validation.errors, loading: false }));
        return false;
      }
      const flatRateOffers = [];
      const psiEligible = propsChosenOffer.productName.includes('PSI');
      const basePrice = propsChosenOffer.productName.includes('PSI')
          && parseInt(propsChosenOffer.basePriceDs, 10) === 0
        ? stateBaseRate
        : propsChosenOffer.basePriceDs;
      flatRateOffers.push({
        flatRateId: 0,
        price: parseFloat(stateEditedRate || propsChosenOffer.rate),
        milesSelected: parseInt(propsChosenOffer.miles, 10),
        psiEligible,
        palv: false,
        aco: true,
        dealerNo: propsChosenOffer.dealerNo,
        targetPrice: parseFloat(propsChosenOffer.rate),
        targetPriceForMiles: parseFloat(propsChosenOffer.rate),
        productId: propsChosenOffer.productId,
        daysSelected:
            propsChosenOffer.exceptionsProductName === 'extendedprotect'
              ? 30
              : parseInt(propsChosenOffer.days, 10),
        productType: propsChosenOffer.productType,
        productName: propsChosenOffer.productName,
        exceptionsProductName: propsChosenOffer.exceptionsProductName,
        basePriceDs: parseInt(basePrice, 10),
        daysPsi: propsChosenOffer.daysPsi,
        isUpgrade: stateIsUpgrade,
        locallyLinked: propsChosenOffer.localLinkedFlag,
      });

      const flatRateOfferInput = {
        auctionAccessNumber: stateAuctionAccessNumber,
        userEmail: stateUserEmail,
        salesRepEmail: stateSalesRepEmail,
        aco: true,
        isDowngrade: true,
        buyerInformation: {
          name: stateAuctionAccessName,
          emails: stateEmail,
          cellPhone: statePhone,
        },
        flatRateOffers,
      };
      createAndAcceptMutation({
        variables: { flatRateOfferInput },
      })
        .then(({ data }) => {
          const {
            createAndAcceptFlatRateOfferBatch: { success, errors: responseErrors },
          } = data;
          if (success) {
            this.setState({
              offerAccepted: true,
              loading: false,
            });
          } else {
            this.setState({
              flashMessage: responseErrors[0],
              loading: false,
            });
          }
        })
        .catch(error => {
          this.setState({
            loading: false,
            flashMessage: error,
          });
        });
      this.setState(prevState => ({ ...prevState, ...validation.errors }));
      return true;
    };

    const submitForm = e => {
      e.preventDefault();
      this.setState({ loading: true });
      const {
        email: stateEmail,
        phone: statePhone,
        editedRate: stateEditedRate,
        baseRate: stateBaseRate,
        auctionAccessName: stateAuctionAccessName,
        auctionAccessNumber: stateAuctionAccessNumber,
        isUpgrade: stateIsUpgrade,
        salesRepEmail: stateSalesRepEmail,
        userEmail: stateUserEmail,
        closedFactoryExclusion: stateClosedFactoryExclusion,
      } = this.state;

      const { createMutation, chosenOffer: propsChosenOffer } = this.props;

      const validation = new Validator(this.state, validationRules, {
        'required.email':
          'Please enter a valid email address for the offer recipient',
        email: 'Please enter a valid email address',
        userEmail: 'Please enter a valid user email address',
        salesRepEmail: 'Please enter a valid Sales Rep email address',
        integer: 'Please enter whole number',
        'required.auctionAccessName': 'Please enter a full name',
      });

      if (
        this.validateEditedRate(stateEditedRate, propsChosenOffer, stateIsUpgrade) === false
        || this.validateChosenIndex(chosenIndex) === false
        || this.validateRevisedOffer(stateEditedRate, propsChosenOffer) === false
        || this.validateChosenOffer(propsChosenOffer, stateEditedRate) === false
        || this.validateEditedRateToOffer(propsChosenOffer, stateEditedRate, stateBaseRate)
          === false
        || this.validateBaseRate(stateBaseRate, propsChosenOffer, stateIsUpgrade) === false
      ) {
        return false;
      }

      if (validation.fails()) {
        this.setState(prevState => ({ ...prevState, ...validation.errors, loading: false }));
        return false;
      }
      const flatRateOffers = [];
      const psiEligible = propsChosenOffer.productName.includes('PSI');
      const basePrice = propsChosenOffer.productName.includes('PSI')
          && parseInt(propsChosenOffer.basePriceDs, 10) === 0
        ? stateBaseRate
        : propsChosenOffer.basePriceDs;
      flatRateOffers.push({
        flatRateId: 0,
        price: parseFloat(stateEditedRate || propsChosenOffer.rate),
        milesSelected: parseInt(propsChosenOffer.miles, 10),
        psiEligible,
        palv: false,
        aco: true,
        dealerNo: propsChosenOffer.dealerNo,
        targetPrice: parseFloat(propsChosenOffer.rate),
        targetPriceForMiles: parseFloat(propsChosenOffer.rate),
        productId: propsChosenOffer.productId,
        daysSelected:
            propsChosenOffer.exceptionsProductName === 'extendedprotect'
              ? 30
              : parseInt(propsChosenOffer.days, 10),
        productType: propsChosenOffer.productType,
        productName: propsChosenOffer.productName,
        exceptionsProductName: propsChosenOffer.exceptionsProductName,
        basePriceDs: parseInt(basePrice, 10),
        daysPsi: propsChosenOffer.daysPsi,
        isUpgrade: stateIsUpgrade,
        locallyLinked: propsChosenOffer.localLinkedFlag,
        closedFactoryExclusion: Boolean(stateClosedFactoryExclusion),
      });

      const flatRateOfferInput = {
        auctionAccessNumber: stateAuctionAccessNumber,
        userEmail: stateUserEmail,
        salesRepEmail: stateSalesRepEmail,
        aco: true,
        buyerInformation: {
          name: stateAuctionAccessName,
          emails: stateEmail,
          cellPhone: statePhone,
        },
        flatRateOffers,
      };
      createMutation({
        variables: { flatRateOfferInput },
      })
        .then(({ data }) => {
          const {
            createFlatRateOfferBatch: { success, errors: responseErrors },
          } = data;
          if (success) {
            this.setState({
              showConfirm: true,
              flashMessage: null,
              loading: false,
            });
          } else {
            this.setState({
              flashMessage: responseErrors,
              loading: false,
            });
          }
        })
        .catch(error => {
          this.setState({
            loading: false,
            flashMessage: error,
          });
        });
      this.setState(prevState => ({ ...prevState, ...validation.errors }));
      return true;
    };

    const checked = !(chosenIndex === '');

    const listRow = ListRow(
      handleRadioButtonChange,
      this.fieldUpdateHandler,
      chosenIndex,
      editedRate,
      baseRate,
      isRevise,
      errors
    );

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell width={5}>PRODUCT*</Table.HeaderCell>
        <Table.HeaderCell width={2}>RATE**</Table.HeaderCell>
        {!checked && <Table.HeaderCell className='enrollment-link' />}
        {checked && (
          <Table.HeaderCell width={2} className='enrollment-link'>
            OVERRIDE
          </Table.HeaderCell>
        )}
        {checked
          && chosenOffer.productName.includes('PSI')
          && parseInt(chosenOffer.basePriceDs, 10) === 0 && (
            <Table.HeaderCell width={2} className='enrollment-link'>
              BASE RATE
            </Table.HeaderCell>
        )}
        <Table.HeaderCell width={7} className='enrollment-link' />
      </Table.Row>
    );

    return (
      <div>
        <Form>
          <h1> Enrollment </h1>
          {!isRevise && isUpgrade && (
            <Message
              header={`Current product for ${selectedDealerNo} ${selectedDealerName} is ${productname} at $ ${parseInt(
                enrollment[0].rate,
                10
              )}.`}
              content='Please select a new product.'
              className='header-content-aco'
            />
          )}
          {!isRevise && !isUpgrade && (
            <Message
              header={`QUOTES FOR - ${selectedDealerNo} - ${selectedDealerName}`}
            />
          )}
          {isRevise && incompleteEnrollment && (
            <Message
              header={`Revising offer sent to ${auctionAccessName} for ${selectedDealerName} for`}
              content={`${incompleteEnrollment.productName} at $${
                incompleteEnrollment.price
              }, sent ${incompleteEnrollment.sendAt}`}
              className='header-content-aco'
            />
          )}
          {flashMessage && (
            <Message
              onDismiss={this.handleDismiss}
              content={flashMessage}
              negative
            />
          )}
          <div>
            <Table
              celled
              selectable
              padded
              renderBodyRow={listRow}
              tableData={offers}
              headerRow={headerRow}
              size='small'
              striped
              compact='very'
              style={{ fontSize: '90%' }}
            />
            <div>
              <span>
                <label htmlFor='closedFactoryExclusion'>Closed Factory Exclusion</label>
                <Checkbox
                  id='closedFactoryExclusion'
                  className='item-checkbox-right'
                  checked={closedFactoryExclusion}
                  onChange={onCheckboxHandler('closedFactoryExclusion')}
                />
              </span>
            </div>
            <br />
            <ContactForm
              email={email}
              phone={phone}
              auctionAccessName={auctionAccessName}
              userEmail={userEmail}
              salesRepEmail={salesRepEmail}
              fieldUpdateHandler={this.fieldUpdateHandler}
              submitForm={submitForm}
              submitWithoutApproval={submitWithoutApproval}
              handleCancel={handleCancel}
              isRevise={isRevise}
              loading={loading}
              flashMessage={flashMessage}
              errors={errors}
              selectedDealerNo={selectedDealerNo}
              selectedDealerName={selectedDealerName}
              enrollment={enrollment}
              chosenOffer={chosenOffer}
              isUpgrade={isUpgrade}
              editedRate={editedRate}
            />
            <br />
            {showConfirm && (
              <Confirm
                className='confirm-form'
                open
                content='An email offer will be sent and the offer will be tracked in Tappy'
                onConfirm={handleConfirm}
              />
            )}
            {offerAccepted && (
              <Confirm
                className='confirm-form'
                open
                content={`Dealer ${chosenOffer.dealerNo} ${selectedDealerName} \
                has been changed in SAS to ${chosenOffer.productName} at \
                $ ${parseFloat(editedRate || chosenOffer.rate)} \
                and a confirmation has been sent to Customer Service`}
                onConfirm={handleAccepted}
              />
            )}
          </div>
        </Form>
      </div>
    );
  }
}

ProductSelection.propTypes = {
  selectedDealerNo: PropTypes.string,
  selectedDealerName: PropTypes.string,
  auctionAccessName: PropTypes.string,
  offers: PropTypes.array,
  email: PropTypes.string,
  phone: PropTypes.string,
  auctionAccessNumber: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  handleRadioButtonChange: PropTypes.func.isRequired,
  isUpgrade: PropTypes.bool,
  userEmail: PropTypes.string,
  salesRepEmail: PropTypes.string,
  enrollment: PropTypes.array,
  handleProductSelection: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  isRevise: PropTypes.bool,
  onSearchSubmitHandler: PropTypes.func.isRequired,
  chosenIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chosenOffer: PropTypes.object,
  createMutation: PropTypes.func.isRequired,
  createAndAcceptMutation: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  graphql(createFlatRateOfferMutation, { name: 'createMutation' }),
  graphql(createAndAcceptFlatRateOfferMutation, {
    name: 'createAndAcceptMutation',
  })
)(ProductSelection);
